/** scss */
import "./user-layout.scss";

/** layouts */
import BaseLayout from "../base-layout/base-layout";

const UserLayout = ({ title, children }) => {
  return <BaseLayout title={title} children={children}></BaseLayout>;
};

export default UserLayout;
